// extracted by mini-css-extract-plugin
export default {"content":"TokenRequired_content__xF5yH","text":"TokenRequired_text__YJRqa","buttons":"TokenRequired_buttons__qHOTl","icon":"TokenRequired_icon__fIV6Q"};